import { createContext } from "react";

export type PerfilContextType = {
  getUsuarios: () => Promise<any>;
  confereSenha: (senha: string) => Promise<any>;
};

export const PerfilContext = createContext<PerfilContextType>(null!);
